import {SoundPlayer} from '@fantasmagames/slot/src/sound/SoundPlayer';
import {Logic} from '@fantasmagames/slot/src/logic/Logic';
import Sound = PIXI.sound.Sound;

export class GameSoundPlayer extends SoundPlayer {

	protected _musicToPlaySimult: string[] = [
		'mainMusic1',
		'mainMusic2',
		'mainMusic3',
	];

	protected _isMainMusicStarted: boolean = false;

	protected startAllMusic(): void {
		for (const musName of this._musicToPlaySimult) {
			const music: Sound = this._soundManager.getMusic(musName);
			if (music) {
				music.loop = true;
				music.volume = 0;
				music.play();
			}
		}
	}

	public stopMusic(): void {
		for (const musName of this._musicToPlaySimult) {
			const music: Sound = this._soundManager.getMusic(musName);
			if (music) {
				music.stop();
			}
		}
		super.stopMusic();

		this._isMainMusicStarted = false;
	}

	public fadeCurrentMusicTo(musicID: string, transitionDuration: number = null): void {
		if (!this._isMainMusicStarted) {
			this._isMainMusicStarted = true;
			this.startAllMusic();
		}
		super.fadeCurrentMusicTo(musicID, transitionDuration);
	}

	public restoreGameMusic(logic: Logic): void {
		// NO OP
	}
}


// WEBPACK FOOTER //
// ./src/sound/GameSoundPlayer.ts